// upload slot directive
//
// allows you to use the BoxCast media hosting infrastructure to
// input a URL or allow a new uploaded image/video.
//
//   <upload-slot ng-model="vm.myUploadedFile"
//                ng-change="vm.onUploadChange()"
//                allow-image="true"
//                allow-video="true"
//                slot-name="account"
//                ></upload-slot>
//
// the ng-model object that you get out is a special FileReader-like object
// with a few additional attributes:
//
//    upload() - function, returns promise when upload is complete with the
//               AccountUpload metadata response from the BoxCast API
//    videoDuration - float, seconds, if able to be computed by the browser
//
//
// Depends on https://github.com/danialfarid/ng-file-upload

let module = angular.module('app.directives');

module.directive('uploadSlot', (toaster, $q, $uibModal, $timeout, AccountUploadsService) => {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      ngChange: '@',
      slotName: '=',
      allowImage: '=',
      allowVideo: '=',
      compact: '=',
      hideRecentBrowse: '=',
      hideStockBrowse: '=',
      clearOnSuccess: '=',
    },
    require: 'ngModel',
    template: require('./upload-slot.html'),
    link: (scope, element, attrs, ngModelCtrl) => {
      const { allowVideo, allowImage, slotName, hideRecentBrowse, hideStockBrowse } = scope;

      var cfg = AccountUploadsService.uploadConfiguration(allowVideo, allowImage, slotName);

      scope.rules = cfg.rules;
      scope.fileTypeSentence = cfg.fileTypeSentence;
      scope.helpText = cfg.helpText;
      scope.showVideoHelp = cfg.showVideoHelp;

      scope.skipBrowseModal = hideRecentBrowse && hideStockBrowse;

      if (attrs.ngChange) {
        ngModelCtrl.$viewChangeListeners.push(function () {
          scope.$eval(attrs.ngChange);
        });
      }

      scope.browse = () => showBrowseDialog();

      scope.$watch('file', (newFile, oldFile) => {
        if (newFile && newFile.__avoidUpload) {
          // Do nothing; result of browsing for other file
        } else if (newFile) {
          updateDataBinding({
            upload: (args) => uploadFile(args),
            file: newFile,
          });
        } else if (oldFile) {
          scope.file = null;
          updateDataBinding(null);
        } else {
          scope.file = null;
          // first load, no need to do anything
        }

        if (newFile && newFile.type) {
          var parts = newFile.type.split('/');
          scope.fileType = parts.length < 2 ? '' : parts[1];
        } else {
          scope.fileType = '';
        }
      });

      // Wait for <video> preview to render so that we can try to compute duration
      scope.$watch(
        () => scope.file && element.find('video').get(0),
        (videoElement) => {
          if (videoElement) {
            videoElement.addEventListener('loadeddata', function () {
              console.log('Assigning video duration to upload candidate');
              scope.ngModel.videoDuration = videoElement.duration;
              updateDataBinding(scope.ngModel);
            });
          }
        }
      );

      scope.$watch('invalidFile', (err) => {
        if (err) {
          console.warn('Invalid file upload attempted', err);
          toaster.pop(
            'warning',
            `Invalid file (${err.$error} should be ${err.$errorParam}). Please try another file.`
          );
        }
      });

      scope.$on('$destroy', function () {
        AccountUploadsService.destroy();
      });

      function updateDataBinding(value) {
        scope.ngModel = value;
        ngModelCtrl.$setViewValue(value);
        ngModelCtrl.$commitViewValue();
        if (value && scope.onChange) {
          scope.onChange(value);
        }
      }

      function showBrowseDialog() {
        $uibModal
          .open({
            template: require('./upload-slot-browse.html'),
            controller: require('./upload-slot-browse.js').default,
            controllerAs: 'vm',
            resolve: {
              params: () => {
                return {
                  slotName: scope.slotName,
                  allowImage: scope.allowImage,
                  allowVideo: scope.allowVideo,
                  hideRecentBrowse: scope.hideRecentBrowse,
                  hideStockBrowse: scope.hideStockBrowse,
                };
              },
            },
          })
          .result.then((result) => {
            console.log('Back in <upload-slot>. Browse completed with result', result);
            if (result.type == 'file') {
              // Trigger watcher as if you had drag/dropped
              scope.file = result.result;
            } else if (result.type == 'upload') {
              // Already in our uploads subsystem, skip ahead a bit
              // XXX: touching `file` here triggers the watcher
              var f = result.result;
              scope.file = {
                __avoidUpload: true,
                name: f.filename,
                type: f.mimetype,
                size: f.filesize,
              };
              updateDataBinding({
                upload: () => $q((resolve) => resolve(result.result)),
                videoDuration: null,
              });
            } else if (result.type == 'url') {
              // Skip ahead even further by just passing the URL along
              updateDataBinding({
                upload: () => $q((resolve) => resolve({ view_url: result.result })),
                videoDuration: null,
              });
            }
          });
      }

      function uploadFile(args) {
        const { file, slotName } = scope;

        return AccountUploadsService.processFileAndUpload(file, slotName, args)
          .then((data) => {
            if (scope.clearOnSuccess) {
              $timeout(() => (scope.file = null), 1000);
            }
            return data;
          })
          .catch((err) => {
            console.error('Error acquiring upload path:', err);
            toaster.pop('warning', `File ${file.name} failed to upload.`);
            file.status = 'error';
            throw err;
          });
      }
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/upload-slot.js